export function formatAbsenCoordinates(latitude, longitude) {
  if (latitude == null || longitude == null ||
      String(latitude).trim() === '' || String(longitude).trim() === '') return '';

  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) ||
      Math.abs(lat) > 90 || Math.abs(lng) > 180) return '';

  return `${lat}, ${lng}`;
}
